module.exports = __webpack_public_path__ + "assets/scorestream-white-full-3708f4487fea609c8e1ff0e449ea0f78.png";